<script>
export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    name: "afterSale",
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <!-- 申请售后 售后服务 -->
    <div class="table after_sale">
        <div class="item thead only_pc">
            <div class="tr">
                <div class="td">退货商品</div>
                <div class="td">订单编号</div>
                <div class="td">退款金额</div>
                <div class="td">数量</div>
            </div>
        </div>
        <div class="item">
            <div class="tr only_pc">
                <div class="td">
                    <div class="info">
                        <router-link class="cover layout_bg" :style="`background-image: url(${data.goods.item_image});`" :to="`/shop/detail?id=${data.goods.item_id}`"></router-link>
                        <div class="wrapper">
                            <p class="name">
                                <router-link :to="`/shop/detail?id=${data.goods.item_id}`">{{data.goods.item_name}}</router-link>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="td layout_flex_center">{{ data.order_code }}</div>
                <div class="td layout_flex_center">RMB {{data.goods.total_price}}</div>
                <div class="td layout_flex_center">{{ data.goods.qty }}</div>
            </div>
            <!-- 移动端 -->
            <div class="only_mobile">
                <div class="info">
                    <router-link class="cover layout_bg" :style="`background-image: url(${data.goods.item_image});`" :to="`/shop/detail?id=${data.goods.item_id}`"></router-link>
                    <div class="wrapper">
                        <p class="name"><router-link :to="`/shop/detail?id=${data.goods.item_id}`">{{data.goods.item_name}}</router-link></p>
                        <p class="count">x{{data.goods.qty}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
@import './table.scss';
.after_sale{
    border-bottom: 1px solid #ebebeb;
    @media screen and (max-width: 750px) {
        border-bottom: none;
    }
    .tr{
        .td{
            flex: 1;
            &:nth-of-type(1){
                flex: none;
                width: 38%;
            }
        }
    }
    .item{
        @media screen and (max-width: 750px) {
            padding-top: 0;
            padding-bottom: 0;
        }
        &.thead{
            border-bottom: none;
        }
    }
}
</style>